
export const getSlicedLeftSubNavigationItems = (navigationItem) => {
    const slicedLeftSubNavigationItemIds = navigationItem?.slicedLeftSubNavigationItemIds;
    if(!slicedLeftSubNavigationItemIds) {
        return [];
    }
    return slicedLeftSubNavigationItemIds.map((id) =>
        navigationItem.subNavigationItems.find((subItem) => subItem.id === id),
    );
};

export const getSlicedTopSubNavigationItems = (navigationItem) => {
    const slicedTopSubNavigationItemIds = navigationItem?.slicedTopSubNavigationItemIds;
    if(!slicedTopSubNavigationItemIds) {
        return [];
    }
    return slicedTopSubNavigationItemIds.map((id) =>
        navigationItem.subNavigationItems.find((subItem) => subItem.id === id),
    );
};

export const getMobileNavigationItems = (navigationItem) => {
    const subItems = navigationItem?.subNavigationItems ?? [];
    const overviewItems = subItems.filter(item => item.overviewItem);
    const nonOverviewItems = subItems.filter(item => !item.overviewItem);

    // Hide overview tile when a channel exposes exactly one direct subshop
    if (overviewItems.length === 1 && nonOverviewItems.length === 1) {
        const onlySubshop = nonOverviewItems[0];
        const onlySubshopItems = onlySubshop.subNavigationItems ?? [];
        const hasSubshopItems = onlySubshopItems.some(item => !item.overviewItem);

        if (!hasSubshopItems) {
            return nonOverviewItems;
        }
    }

    return [...overviewItems, ...nonOverviewItems];
};

export const getOnlyDirectSubshop = (navigationItem) => {
    const nonOverviewItems = navigationItem?.subNavigationItems?.filter(item => !item.overviewItem) ?? [];

    if (nonOverviewItems.length !== 1) {
        return null;
    }

    const onlySubshop = nonOverviewItems[0];
    const onlySubshopItems = onlySubshop.subNavigationItems ?? [];
    const hasSubshopItems = onlySubshopItems.some(item => !item.overviewItem);

    return hasSubshopItems ? null : onlySubshop;
};
